export const navigateToFile = (url, target = '_blank') => {
  window.open(url, target);
};
